import Instance from '../../../../Axios';

// New Actions for the app

const GetAeroportos = () => async (dispatch) => {
  await Instance()
    .get(`/aeroportos`)
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: 'GET_AEROPORTOS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetAeroportos;
